// src/utils/chat-client.js
import { Agent } from "@livechat/lc-sdk-js";
import { getAccessTokenStore, getAccessRegionStore, getAccessNameStore } from "./store";

// 获取 token
export const getToken = () => {
  return getAccessTokenStore();
};

// TokenGetter（注意大小写字段）
const tokenGetter = () => ({
  accessToken: getAccessTokenStore(),
  organizationID: process.env.REACT_APP_LC_ORG_ID,
  region: getAccessRegionStore(),
  tokenType: "Bearer",
});

let agentWebInstance = null;
let agentRTMInstance = null;

/**
 * 获取 Agent Web 单例实例
 */
export const getAgentWeb = () => {
  if (!agentWebInstance) {
    agentWebInstance = new Agent.Web(
      process.env.REACT_APP_LC_LICENSE_ID,
      tokenGetter,
      { debug: true }
    );
  }
  return agentWebInstance;
};

/**
 * 获取 Agent RTM 单例实例
 */
export const getAgentRTM = () => {
  if (!agentRTMInstance) {
    console.log("tokenGetter-------------", tokenGetter)
    agentRTMInstance = new Agent.RTM(WebSocket, tokenGetter);
  }
  return agentRTMInstance;
};

// 使用 Web API 方法封装（通过单例）
export const getChatsList = () => {
  const chats = getAgentWeb().listChats({ limit: 100 });
  console.log("getChatsList------", chats)
  return chats;
}


export const getArchives = () =>{
  return getAgentWeb().listArchives({ pagination: { limit: 10 } })
}
  ;

export const getChat = (chatId, threadId) =>
{
  return getAgentWeb().getChat(chatId, threadId);
}
  

export const sendEvent = (chatId, text) =>
{
   return getAgentWeb().sendEvent(chatId, {
    type: "message",
    text,
  });
}
   


export const closeChatById = (chatId) => {
  try {
    getAgentWeb().deactivateChat(chatId, true);
    console.log("Chat closed:", chatId);
    return true
  } catch (error) {
    console.error("Failed to close chat:", error);
    return false;
  }
}


export const uploadFileAndSend =async  (formData,chatId) => {
  try {
    const uploadRes =await  getAgentWeb().uploadFile(formData, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  
    if (!uploadRes?.file?.url) {
      throw new Error("上传成功但文件 URL 缺失");
    }

    const { name, url, content_type, size } = uploadRes.file;

    const sendRes = await getAgentWeb().sendEvent(chatId, {
      type: "file",
      file: { name, url, content_type, size }
    });

    if (sendRes?.event_id) {
      console.log("✅ 文件发送成功！", sendRes.event_id);
      return true;
    } else {
      console.error("❌ 文件发送响应异常", sendRes);
      return false;
    }
  } catch (error) {
    console.error("❌ 文件上传失败:", error);
    return false;
  }
}

export const getAgentLoginName = () => {
  return getAccessNameStore()
  // try {
  //   const rtm = getAgentRTM();
  //   const session = rtm.getCurrentSession();
  //   const agentId = session.agentId;
  //   const profile = await getAgentWeb().get({ agentId });
  //   return profile.login || "";
  // } catch (error) {
  //   console.warn("Failed to get agent login name:", error);
  //   return "";
  // }
};
